import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { createUseStyles } from 'react-jss';
import Logo from './icons/logo.svg';
import Eye from './icons/eye.svg';
import Check from './icons/check.svg';
var IconWrapper = function IconWrapper(Component, width, height) {
  var IconWrapperStyles = {
    container: {
      width: "".concat(width / 10, "rem"),
      height: "".concat(height / 10, "rem")
    }
  };
  var useStyles = createUseStyles(IconWrapperStyles);
  var IconAsset = function IconAsset(props) {
    var classes = useStyles(props);
    var className = props.className;
    return /*#__PURE__*/React.createElement(Component, {
      className: cx(classes.asset, className)
    });
  };
  IconAsset.useStyles = useStyles;
  IconAsset.width = "".concat(width / 10, "rem");
  IconAsset.height = "".concat(height / 10, "rem");
  IconAsset.propTypes = {
    className: PropTypes.string
  };
  IconAsset.defaultProps = {
    className: ''
  };
  return IconAsset;
};
var icons = {
  Logo: IconWrapper(Logo, 140, 40),
  Eye: IconWrapper(Eye, 25, 16),
  Check: IconWrapper(Check, 9, 6)
};
export default icons;